module.exports = __webpack_public_path__ + "img/PPDIOO高级服务.08c25f20.png";